import { GETREQUESTLIST_SUCCESS, GETREQUESTLIST_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getRequestListReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETREQUESTLIST_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETREQUESTLIST_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getRequestListReducer;
